import { Flex, Image } from "@chakra-ui/react";
import { ClickableOverlay } from "../ClickableOverlay";

const imageFiles = [
  { fileName: "3faces", altText: "an endless inner struggle" },
  { fileName: "Candy_cats", altText: "carefree at the mall with friends" },
  { fileName: "Dedfr", altText: "Cat boy experiences his final moment" },
  {
    fileName: "Inner_world",
    altText: "I am somewhere else entirely most of the time",
  },
  {
    fileName: "Deadinroad",
    altText: "varying reactions to watching a life end",
  },
  { fileName: "Starciggies", altText: "who is she" },
  {
    fileName: "Healthcare",
    altText: "going to the doctor is actual Hell you can't make me go",
  },
  { fileName: "Stargrlz", altText: "sketches of candy girls" },
];

export const Home = () => {
  return (
    <Flex
      rowGap={22}
      gap={2}
      flexWrap="wrap"
      m="0px auto"
      justifyContent="center"
      alignItems="center"
    >
      {imageFiles.map((file) => (
        <ClickableOverlay key={file.fileName} label={file.altText}>
          <Image
            maxW="90vw"
            maxH="70vh"
            alt={file.altText}
            src={`/gallery/${file.fileName}.png`}
            padding={2}
          />
        </ClickableOverlay>
      ))}
    </Flex>
  );
};
